import React, { useEffect, useRef, useState } from "react";
import {
  dotNumberBlurValidation,
  dotNumberValidation,
  makeAjax,
  respStatus,
  showMessage,
  url,
  withDotValidation,
} from "../../../../helpers/global_helper";
import { useSelector, useDispatch } from "react-redux";
import { withTranslation } from "react-i18next";
import ErrorInnerPopup from "../../../Popups/ErrorInnerPopup";
import ErrorPopup from "../../../Popups/ErrorPopup";
import BetSuccessPopup from "../../../Popups/BetSuccessPopup";
import ConfirmBetDeskonPopup from "../../../Popups/ConfirmBetDeskonPopup";
import CancelledBetDeskonPopup from "../../../Popups/CancelledBetDeskonPopup";
import { getUserBalance, setCommonConfig } from "../../../../redux/actions";
import GameClosedPopup from "../GameClosedPopup";
import MarketClose from "../MarketClose";
import CommonBetHeader from "../CommonBetHeader";

const ColokJitu = (props) => {
  const dispatch = useDispatch();
  const device = useSelector((state) => state.CommonConfig.device_type);
  const gameId = useSelector((state) => state.CommonConfig.gameId);
  const betDiscount = useSelector((state) => state.CommonConfig.discount);
  const [succMessage, setSuccessMessage] = useState("");
  const [showGameClose, setShowGameClose] = useState(false);
  const [showMarketClose, setShowMarketClose] = useState(false);
  const [prizeDiscount, setPrizeDiscount] = useState();
  const [reqData, setReqData] = useState({
    isfullbet: null,
    gameId: null,
    gameType: "colokjitu",
    action: "process",
    betTogelAuth: "betTogelAuth",
    allowPartner: "allowPartner",
    dataangka: [],
  });

  const [rowsToShow, setRowsToShow] = useState(10);
  const [inputValues, setInputValues] = useState({});
  const [invalidRows, setInvalidRows] = useState([]);
  const [showErrorPopup, setShowErrorPopup] = useState(false);
  const [errorMessages, setErrorMessages] = useState([]);
  const [highlightRow, setHighlightRow] = useState(false);
  const [successPopup, setSuccessPopup] = useState(false);
  const [respData, setRespData] = useState([]);
  const [showConfirmationPopup, setShowConfirmationPopup] = useState(false);
  const [showCancelledPopup, setShowCanclledPopup] = useState(false);
  const guessRefs = useRef([]);
  const positionRefs = useRef([]);
  const buyRefs = useRef({});
  const [totalBetAmount, setTotalBetAmount] = useState()
  const [defaultValue, setDefaultvalue] = useState("");

  const handleInputFocus = (e, rowIndex, columnName) => {
    if (defaultValue !== '') {
      let value = defaultValue;

      if (defaultValue > betDiscount.showMax / 1000) {
        setErrorMessages(props.t("you_have_reached_max_bet_value"));
        setShowErrorPopup(true);
        return;
      }
      setHighlightRow(false);
      setErrorMessages([]);
      setShowErrorPopup(false);

      const newInputValues = { ...inputValues };

      if (columnName === "guess" || columnName === "buy") {
        if (columnName === "guess" && value.length > 1) {
          value = value.slice(-1);
        }

        if (columnName === "buy" && value !== "") {
          const numericValue = Number(value);
          // if (numericValue < betDiscount.showMin / 1000) {
          //   setErrorMessages(props.t("minimum_bet_is_1"));
          //   setShowErrorPopup(true);
          //   return;
          // }
          if (betDiscount && numericValue > betDiscount.showMax / 1000) {
            setErrorMessages(props.t("you_have_reached_max_bet_value"));
            setShowErrorPopup(true);
            return;
          }
        }
      }

      if (!newInputValues[rowIndex]) {
        newInputValues[rowIndex] = { guess: "", position: "", buy: "" };
      }

      if (columnName === "guess" && value === "") {
        newInputValues[rowIndex] = { guess: "", position: "", buy: "" };
      } else {
        newInputValues[rowIndex][columnName] = value;
      }
      setInputValues(newInputValues);
      // Update the total bet amount when focus is triggered (ensure calculation runs here)
      calculateTotalBetAmount(newInputValues);

      const rowValues = newInputValues[rowIndex];
      const isRowComplete = rowValues.guess !== '' && rowValues.position !== '' && rowValues.buy !== '';

      const newInvalidRows = [...invalidRows];

      if (columnName === "guess" && value === "") {
        newInvalidRows.push(rowIndex);
      } else {
        const index = newInvalidRows.indexOf(rowIndex);
        if (index > -1) {
          newInvalidRows.splice(index, 1);
        }
      }

      if (!isRowComplete) {
        if (!newInvalidRows.includes(rowIndex)) {
          newInvalidRows.push(rowIndex);
        }
      } else {
        const index = newInvalidRows.indexOf(rowIndex);
        if (index > -1) {
          newInvalidRows.splice(index, 1);
        }
      }

      setInvalidRows(newInvalidRows);

      // Check previous row completion
      if (rowIndex > 0) {
        const prevRowValues = newInputValues[rowIndex - 1];
        if (prevRowValues !== undefined) {
          if (!prevRowValues || !prevRowValues.guess || !prevRowValues.position || !prevRowValues.buy) {
            return;
          }
        }
      }

      // Update reqData
      const dataangka = Object.keys(newInputValues).map((key) => {
        const row = newInputValues[key];
        return [`${row.guess}-${row.position}`, row.buy * betDiscount.showMultiple];
      });

      setReqData({
        ...reqData,
        dataangka: dataangka,
        gameId: gameId,
      });

      // Focus management
      if (columnName === "guess" && value) {
        positionRefs.current[rowIndex].focus();
      } else if (columnName === "position") {
        let newIndex = `${rowIndex}-buy`
        buyRefs.current[newIndex].focus();
      }
    }
  };


  const handleInputBlur = (e, rowIndex, columnName) => {
    let { name, value } = e.target;
    value = value.replace(',', '.');
    let regex = '';
    if (String(betDiscount.showMin).length === 3) {
      regex = /^\d*([.,]\d?)?$/;
      value = dotNumberBlurValidation(value);
    } else {
      regex = /^\d*$/;
      value = withDotValidation(value);
    }
    e.target.value = value;
    handleInputChange(e, rowIndex, columnName);
  }
  const handleInputChange = (e, rowIndex, columnName) => {
    let value = e.target.value;
    value = value.replace(',', '.');

    setHighlightRow(false);
    setErrorMessages([]);
    setShowErrorPopup(false);

    const newInputValues = { ...inputValues };

    if (columnName === "guess" || columnName === "buy") {
      if (columnName === "guess" && value.length > 1) {
        value = value.slice(-1);
      }
      let regex = '';
      if (String(betDiscount.showMin).length === 3) {
        regex = /^\d*([.,]\d?)?$/;
        value = dotNumberValidation(value);
      } else {
        if (columnName === 'buy') {
          regex = /^\d*$/;
          value = withDotValidation(value);
        } else {
          regex = /^[0-9]*$/;
        }
      }
      if (!regex.test(value)) {
        return;
      }
      // if (value !== "" && (isNaN(value) || !Number.isInteger(Number(value)))) {
      //   return;
      // }
      if (columnName === "buy" && value !== "") {
        const numericValue = Number(value);
        // if (numericValue < betDiscount.showMin / 1000) {
        //   setErrorMessages(props.t("minimum_bet_is_1"));
        //   setShowErrorPopup(true);
        //   return;
        // }
        if (betDiscount && numericValue > betDiscount.showMax / 1000) {
          setErrorMessages(props.t("you_have_reached_max_bet_value"));
          setShowErrorPopup(true);
          return;
        }
      }
    }

    if (!newInputValues[rowIndex]) {
      newInputValues[rowIndex] = { guess: "", position: "", buy: "" };
    }

    if (columnName === "guess" && value === "") {
      newInputValues[rowIndex] = { guess: "", position: "", buy: "" };
    }
    else {
      newInputValues[rowIndex][columnName] = value;
    }



    const rowValues = newInputValues[rowIndex];
    const isRowComplete = rowValues.guess !== '' && rowValues.position !== '' && rowValues.buy !== '';

    const newInvalidRows = [...invalidRows];

    if (columnName === "guess" && value === "") {
      newInvalidRows.push(rowIndex);
    } else {
      const index = newInvalidRows.indexOf(rowIndex);
      if (index > -1) {
        newInvalidRows.splice(index, 1);
      }
    }

    if (!isRowComplete) {
      if (!newInvalidRows.includes(rowIndex)) {
        newInvalidRows.push(rowIndex);
      }
    } else {
      const index = newInvalidRows.indexOf(rowIndex);
      if (index > -1) {
        newInvalidRows.splice(index, 1);
      }
    }

    setInvalidRows(newInvalidRows);

    // Check previous row completion
    if (rowIndex > 0) {
      const prevRowValues = newInputValues[rowIndex - 1];
      if (prevRowValues !== undefined) {
        // if (!prevRowValues || !prevRowValues.guess || !prevRowValues.position || !prevRowValues.buy) {
        //   return;
        // }
      }
    }

    // Update reqData
    if (columnName === "guess" && value) {
      positionRefs.current[rowIndex].focus();
    } else if (columnName === "position" && value) {
      let newIndex = `${rowIndex}-buy`
      buyRefs.current[newIndex].focus();
      newInputValues[rowIndex]['buy'] = defaultValue ? defaultValue : '';

    }

    setInputValues(newInputValues);

    calculateTotalBetAmount(newInputValues);

    const dataangka = Object.keys(newInputValues).map((key) => {
      const row = newInputValues[key];
      return [`${row.guess}-${row.position}`, row.buy * betDiscount.showMultiple];
    });

    setReqData({
      ...reqData,
      dataangka: dataangka,
      gameId: gameId,
    });

    // Focus management

  };

  useEffect(() => {
    makeAjax(url.TOGEL_API.getTogelDetails, { "gameId": gameId, "gameType": reqData.gameType }).then((response) => {
      if (response.status !== respStatus["SUCCESS"]) {
        showMessage(response);
        return;
      }
      setPrizeDiscount(response.data.showDisc);
    })
  }, [gameId])

  const calculateTotalBetAmount = (updatedInputValues) => {
    let total = 0;
    let discount = prizeDiscount / 100; // Assuming prizeDiscount is a percentage (e.g., 10 for 10%)

    // Loop through the updated input values
    Object.keys(updatedInputValues).forEach((key) => {
      const row = updatedInputValues[key];
      if (row.buy && !isNaN(row.buy)) {
        total += row.buy * betDiscount.showMultiple; // Assuming buy value is multiplied by 1000
      }
    });

    // Apply the discount
    const discountedTotal = total * (1 - discount); // Applying the prize discount

    // Update the total bet amount with the discounted value
    setTotalBetAmount(discountedTotal);
  };

  const invalidStyle = {
    border: "2px solid red",
    backgroundColor: "#ffe6e6",
  };

  const confirmBet = () => {
    reqData.dataangka = reqData.dataangka.filter((entry) => entry[1] !== 0);

    if (reqData.dataangka.length < 1) {
      setErrorMessages(props.t("guess_bet_wrong"));
      setShowErrorPopup(true);
    } else {
      setSuccessMessage("");
      setShowConfirmationPopup(true);
    }
  };
  const hideCommonToaster = () => {
    const commonToaster = document.getElementById("commonToaster");
    if (commonToaster) {
      commonToaster.style.display = "none";
    }
  };
  const submitProcessOk = () => {
    setShowConfirmationPopup(false);
    makeAjax(url.TOGEL_API.processAltTogel, reqData).then((response) => {
      if (response.status !== respStatus["SUCCESS"]) {
        if (response.code === "sub_game_status_close") {
          setShowGameClose(true);
          showMessage(false);
          hideCommonToaster();
          dispatch(setCommonConfig({ key: "subGameOnOffStatus", value: 0 }));
          return;
        }
        if (response.code === "market_close_err") {
          setShowMarketClose(true);
          showMessage(false);
          hideCommonToaster();
          dispatch(setCommonConfig({ key: "marketCloseStatus", value: 0 }));
          return;
        }
        if (response.code !== "validation_error") {
          setErrorMessages(props.t(response.code));
          setShowErrorPopup(true);
          return;
        }
        setReqData({
          isfullbet: null,
          gameId: null,
          gameType: "colokjitu",
          action: "process",
          betTogelAuth: "betTogelAuth",
          allowPartner: "allowPartner",
          dataangka: [],
        });
        showMessage(response);
        return;
      }
      setRespData((prevArray) => [...prevArray, response.data]);
      dispatch(getUserBalance());
      setSuccessPopup(true);
      resetBetData();
    });
  };

  useEffect(() => {
    resetBetData();
  }, [gameId]);

  const resetBetData = () => {
    setTotalBetAmount(0);
    setInputValues({});
    setInvalidRows([]);
    setShowErrorPopup(false);
    setErrorMessages([]);
    setHighlightRow(false);
    setReqData({
      isfullbet: null,
      gameId: null,
      gameType: "colokjitu",
      action: "process",
      betTogelAuth: "betTogelAuth",
      allowPartner: "allowPartner",
      dataangka: [],
    });
    setDefaultvalue("")
  };
  const resetRowData = (rowIndex) => {
    setInputValues((prevInputValues) => {
      const newInputValues = { ...prevInputValues };
      if (newInputValues[rowIndex]) {
        newInputValues[rowIndex] = { guess: "", position: "", buy: "" };
      }
      return newInputValues;
    });
    setInvalidRows((prevInvalidRows) =>
      prevInvalidRows.filter((index) => index !== rowIndex)
    );
    setHighlightRow(false);
  };

  const handleDeafultInputBlur = (e) => {
    let value = e.target.value;
    value = value.replace(',', '.');
    let regex = '';
    if (String(betDiscount.showMin).length === 3) {
      regex = /^\d*([.,]\d?)?$/;
      value = dotNumberBlurValidation(value);
    } else {
      regex = /^\d*$/;
      value = withDotValidation(value);
    }
    if (regex.test(value)) {
      setDefaultvalue(value);
    }
  };

  const handleDeafultInputChange = (e) => {
    let value = e.target.value;
    value = value.replace(',', '.');
    let regex = '';
    if (String(betDiscount.showMin).length === 3) {
      regex = /^\d*([.,]\d?)?$/;
      value = dotNumberValidation(value);
    } else {
      regex = /^\d*$/;
      value = withDotValidation(value);
    }
    if (value > betDiscount.showMax / 1000) {
      setErrorMessages(props.t("you_have_reached_max_bet_value"));
      setShowErrorPopup(true);
      return;
    }
    if (regex.test(value)) {
      setDefaultvalue(value);
    }
  };

  const handleClose = () => {
    setRespData([]);
    setSuccessPopup(false);
  };
  const hanldeConfirmationPopupClose = () => {
    setShowConfirmationPopup(false);
    setShowCanclledPopup(true);
  };
  return (
    <div className="colokJitu_wrapper">
      {showGameClose ? (
        <GameClosedPopup />
      ) : showMarketClose ? (
        <MarketClose />
      ) : (
        <>
          <div className="colokJitu_container">
            <div>
              <CommonBetHeader gameName={"colokBebas"} totalBetAmount={totalBetAmount} rowsToShow={null} />
            </div>
            <table>
              <thead>
                <tr className="Heading">
                  <th>{props.t("no.")}</th>
                  <th>{props.t("guess")}</th>
                  <th>{props.t("position")}</th>
                  <th className="d-flex align-right">
                    <input
                      type="text"
                      autoComplete="off"
                      placeholder="Auto Bet"
                      value={defaultValue}
                      onChange={handleDeafultInputChange}
                      onBlur={handleDeafultInputBlur}
                      inputMode="decimal"
                      pattern="[0-9]*[.,]?[0-9]**"
                    />
                  </th>
                  {device === "Desktop" ? null : <th></th>}
                </tr>
              </thead>
              <tbody>
                {[...Array(rowsToShow)].map((_, index) => {
                  const isPreviousRowComplete =
                    index === 0 ||
                    (inputValues[index - 1] &&
                      inputValues[index - 1].guess &&
                      inputValues[index - 1].position &&
                      inputValues[index - 1].buy);

                  return (
                    <tr
                      key={index}
                      className={index % 2 === 0 ? "even-row" : "odd-row"}
                    >
                      <td>{index + 1}</td>
                      <td className="inputs">
                        <input
                          type="text"
                          inputMode="numeric"
                          pattern="[0-9]*"
                          value={inputValues[index]?.guess || ""}
                          onChange={(e) => handleInputChange(e, index, "guess")}
                          style={
                            invalidRows.includes(index) &&
                              highlightRow &&
                              !inputValues[index]?.guess
                              ? invalidStyle
                              : {}
                          }
                          // disabled={!isPreviousRowComplete}
                          ref={(el) => (guessRefs.current[index] = el)}
                        />
                      </td>
                      <td className="inputs">
                        <select
                          value={inputValues[index]?.position || ""}
                          onChange={(e) =>
                            handleInputChange(e, index, "position")
                          }
                          disabled={!inputValues[index]?.guess}
                          ref={(el) => (positionRefs.current[index] = el)}
                          style={
                            invalidRows.includes(index) &&
                              highlightRow &&
                              !inputValues[index]?.position
                              ? invalidStyle
                              : {}
                          }
                        >
                          <option value=""></option>
                          <option value="A">{props.t("As")}</option>
                          <option value="B">{props.t("Kop")}</option>
                          <option value="C">{props.t("Kepala")}</option>
                          <option value="D">{props.t("Ekor")}</option>
                        </select>
                      </td>
                      <td className="inputs">
                        <input
                          type="text"
                          placeholder="Bet"
                          inputMode="decimal"
                          pattern="[0-9]*[.,]?[0-9]**"
                          value={inputValues[index]?.buy || ""}
                          onChange={(e) => handleInputChange(e, index, "buy")}
                          onBlur={(e) => handleInputBlur(e, index, "buy")}
                          onFocus={(e) => handleInputFocus(e, index, "buy")}
                          style={
                            invalidRows.includes(index) &&
                              highlightRow &&
                              !inputValues[index]?.buy
                              ? invalidStyle
                              : {}
                          }
                          // disabled={!isPreviousRowComplete}
                          disabled={!inputValues[index]?.position}
                          ref={(el) => (buyRefs.current[`${index}-buy`] = el)}
                          className="input-bg"
                        />
                      </td>
                      {device === "Desktop" ? null : (
                        <td>
                          {/* <button
                            className="reset-button"
                            onClick={(e) => resetRowData(index)}
                          >
                            reset
                          </button> */}
                        </td>
                      )}
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>

          <div className="last_div">
            <div className="left_div">
              <p>{props.t("guess_one_with_position")}</p>
            </div>
            <div className="right_div">
              <ul className="button-list">
                <li>
                  <button className="reset" onClick={resetBetData}>
                    {props.t("reset")}
                  </button>
                </li>
                <li>
                  <button className="submit" onClick={confirmBet}>
                    {props.t("submit")}
                  </button>
                </li>
              </ul>
            </div>
          </div>
        </>
      )}

      {showErrorPopup && (
        <ErrorInnerPopup
          modalTitle={""}
          modalHeader={true}
          onCloseModal={() => setShowErrorPopup(false)}
        >
          <ErrorPopup
            message={errorMessages}
            onClose={() => setShowErrorPopup(false)}
          />
        </ErrorInnerPopup>
      )}

      {showConfirmationPopup && (
        <ConfirmBetDeskonPopup
          onClose={hanldeConfirmationPopupClose}
          message={succMessage}
          submitProcessOk={submitProcessOk}
        />
      )}
      {showCancelledPopup && (
        <CancelledBetDeskonPopup onClose={() => setShowCanclledPopup(false)} />
      )}
      {successPopup && (
        <div className="popup-overlay">
          <BetSuccessPopup response={respData} onClose={() => handleClose()} />
        </div>
      )}
    </div>
  );
};

export default withTranslation()(ColokJitu);
